module.exports = __webpack_public_path__ + "img/noScore.f17efeb6.png";